import { lazy } from 'react';



export const Error401 = lazy(()=>import('./Error401.jsx'))
export const Error404 = lazy(()=>import('./Error404.jsx'))
export const Error421 = lazy(()=>import('./Error421.jsx'))
export const CountryFilter = lazy(()=>import('./CountryFilter.jsx'))